import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, ArrowRight, Star, CheckCircle } from 'lucide-react';
import { services, testimonials, stats, contactInfo, insurancePartners } from '../mockData';

const Home = () => {
  return (
    <div className="home-page">
      {/* Hero Section */}
      <section className="hero-section">
        <div className="hero-background">
          <img
            src="https://images.unsplash.com/photo-1694025881942-b752102cee95?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAxODF8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBjYXIlMjBnYXJhZ2V8ZW58MHx8fHwxNzY5MTc4Njk1fDA&ixlib=rb-4.1.0&q=85"
            alt="NDV Motors Garage"
            className="hero-image"
          />
          <div className="hero-overlay"></div>
        </div>
        <div className="hero-content container">
          <div className="hero-text">
            <h1 className="hero-title fade-in">
              L'EXCELLENCE<br />
              DE VOTRE<br />
              VÉHICULE
            </h1>
            <p className="hero-subtitle slide-in-left">
              Garage automobile premium à Yutz - Carrosserie, peinture et rénovation de véhicules toutes marques
            </p>
            <div className="hero-buttons slide-in-left">
              <Link to="/devis" className="btn-primary">
                Demander un Devis
                <ArrowRight size={20} />
              </Link>
              <a href={`tel:${contactInfo.phone.replace(/\s/g, '')}`} className="btn-secondary">
                <Phone size={20} />
                Appelez-nous
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Stats Section */}
      <section className="stats-section section-padding">
        <div className="container">
          <div className="stats-grid">
            {stats.map((stat) => (
              <div key={stat.id} className="stat-card fade-in">
                <div className="stat-number">{stat.number}</div>
                <div className="stat-label">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Insurance Partners Section */}
      <section className="insurance-section section-padding">
        <div className="container">
          <div className="section-header text-center mb-60">
            <h2 className="section-title">
              Agréé <span className="text-yellow">Toutes Assurances</span>
            </h2>
            <p className="section-subtitle">
              Nous travaillons avec les principales compagnies d'assurance
            </p>
          </div>
          <div className="insurance-grid">
            {insurancePartners.map((partner, index) => (
              <div
                key={partner.id}
                className={`insurance-card ${partner.isPlaceholder ? 'insurance-placeholder' : ''} fade-in`}
                style={{ animationDelay: `${index * 0.1}s` }}
              >
                {partner.isPlaceholder ? (
                  <div className="insurance-plus">
                    <div className="plus-icon">+</div>
                    <div className="plus-text">Et bien d'autres...</div>
                  </div>
                ) : (
                  <img src={partner.logo} alt={partner.name} className="insurance-logo" />
                )}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* About Preview Section */}
      <section className="about-preview-section section-padding">
        <div className="container">
          <div className="about-preview-grid">
            <div className="about-preview-image slide-in-left">
              <img
                src="https://customer-assets.emergentagent.com/job_ndvmotors/artifacts/ucympth3_WhatsApp%20Image%202024-09-03%20%C3%A0%2013.12.48_639d0365.jpg"
                alt="NDV Motors Garage Extérieur"
              />
            </div>
            <div className="about-preview-content slide-in-right">
              <h2 className="section-title">
                <span className="text-yellow">NDV MOTORS</span><br />
                Votre Garage de Confiance
              </h2>
              <p className="about-preview-text">
                Bienvenue chez NDV Motors, votre garage automobile premium situé à Yutz en Moselle. 
                Spécialisés dans la carrosserie, la peinture et la rénovation esthétique, nous traitons 
                plus de 30 véhicules par semaine avec un soin et une précision inégalés.
              </p>
              <div className="about-features">
                <div className="about-feature">
                  <CheckCircle className="feature-icon" size={24} />
                  <span>Agréé toutes compagnies d'assurance</span>
                </div>
                <div className="about-feature">
                  <CheckCircle className="feature-icon" size={24} />
                  <span>15 véhicules de prêt catégories A, B, C</span>
                </div>
                <div className="about-feature">
                  <CheckCircle className="feature-icon" size={24} />
                  <span>Équipement professionnel de dernière génération</span>
                </div>
                <div className="about-feature">
                  <CheckCircle className="feature-icon" size={24} />
                  <span>Travail soigné et finitions parfaites</span>
                </div>
                <div className="about-feature">
                  <CheckCircle className="feature-icon" size={24} />
                  <span>Prise en charge toutes marques</span>
                </div>
                <div className="about-feature">
                  <CheckCircle className="feature-icon" size={24} />
                  <span>Devis gratuit et conseils personnalisés</span>
                </div>
              </div>
              <Link to="/a-propos" className="btn-primary mt-40">
                En Savoir Plus
                <ArrowRight size={20} />
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section className="services-home-section section-padding">
        <div className="container">
          <div className="section-header text-center mb-60">
            <h2 className="section-title">
              Nos <span className="text-yellow">Services</span> Premium
            </h2>
            <p className="section-subtitle">
              Une expertise complète pour tous vos besoins automobiles
            </p>
          </div>
          <div className="services-grid">
            {services.map((service, index) => (
              <div
                key={service.id}
                className="service-card fade-in"
                style={{ animationDelay: `${index * 0.1}s` }}
              >
                <div className="service-image-container">
                  <img src={service.image} alt={service.title} className="service-image" />
                  <div className="service-overlay"></div>
                </div>
                <div className="service-content">
                  <h3 className="service-title">{service.title}</h3>
                  <p className="service-description">{service.description}</p>
                </div>
              </div>
            ))}
          </div>
          <div className="text-center mt-60">
            <Link to="/services" className="btn-primary">
              Découvrir Tous Nos Services
              <ArrowRight size={20} />
            </Link>
          </div>
        </div>
      </section>

      {/* Testimonials Section */}
      <section className="testimonials-section section-padding">
        <div className="container">
          <div className="section-header text-center mb-60">
            <h2 className="section-title">
              Ce Que Disent Nos <span className="text-yellow">Clients</span>
            </h2>
            <p className="section-subtitle">
              La satisfaction client est notre priorité
            </p>
          </div>
          <div className="testimonials-grid">
            {testimonials.map((testimonial, index) => (
              <div
                key={testimonial.id}
                className="testimonial-card fade-in"
                style={{ animationDelay: `${index * 0.15}s` }}
              >
                <div className="testimonial-rating">
                  {[...Array(testimonial.rating)].map((_, i) => (
                    <Star key={i} size={20} fill="#FFC107" color="#FFC107" />
                  ))}
                </div>
                <p className="testimonial-text">"{testimonial.text}"</p>
                <div className="testimonial-author">
                  <div className="author-name">{testimonial.name}</div>
                  <div className="author-date">{testimonial.date}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta-section section-padding">
        <div className="container">
          <div className="cta-content">
            <h2 className="cta-title fade-in">
              Prêt à Redonner Vie à Votre Véhicule ?
            </h2>
            <p className="cta-subtitle slide-in-left">
              Contactez-nous dès maintenant pour un devis gratuit et personnalisé
            </p>
            <div className="cta-buttons slide-in-right">
              <Link to="/contact" className="btn-primary">
                Demander un Devis Gratuit
                <ArrowRight size={20} />
              </Link>
              <a href={`tel:${contactInfo.phone.replace(/\s/g, '')}`} className="btn-secondary">
                <Phone size={20} />
                {contactInfo.phone}
              </a>
            </div>
          </div>
        </div>
      </section>

      <style jsx>{`
        /* Hero Section */
        .hero-section {
          position: relative;
          min-height: 100vh;
          display: flex;
          align-items: center;
          padding: 120px 40px 80px;
          overflow: hidden;
        }

        .hero-background {
          position: absolute;
          inset: 0;
          width: 100%;
          height: 100%;
        }

        .hero-image {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }

        .hero-overlay {
          position: absolute;
          inset: 0;
          background: linear-gradient(135deg, rgba(0, 0, 0, 0.85) 0%, rgba(0, 0, 0, 0.4) 100%);
        }

        .hero-content {
          position: relative;
          z-index: 1;
        }

        .hero-title {
          font-family: 'Montserrat', sans-serif;
          font-weight: 900;
          font-size: clamp(3rem, 8vw, 7rem);
          line-height: 0.9;
          color: var(--brand-yellow);
          text-transform: uppercase;
          margin-bottom: 24px;
          text-shadow: 2px 2px 10px rgba(0, 0, 0, 0.5);
          max-width: 12ch;
        }

        .hero-subtitle {
          font-size: clamp(1rem, 2vw, 1.3rem);
          color: var(--text-primary);
          max-width: 600px;
          line-height: 1.6;
          margin-bottom: 32px;
        }

        .hero-buttons {
          display: flex;
          gap: 20px;
          flex-wrap: wrap;
        }

        /* Stats Section */
        .stats-section {
          background: var(--bg-card);
          border-top: 3px solid var(--brand-yellow);
          border-bottom: 3px solid var(--brand-yellow);
        }

        .stats-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
          gap: 40px;
        }

        .stat-card {
          text-align: center;
          padding: 20px;
        }

        .stat-number {
          font-family: 'Montserrat', sans-serif;
          font-weight: 900;
          font-size: clamp(2.5rem, 5vw, 4rem);
          color: var(--brand-yellow);
          line-height: 1;
          margin-bottom: 12px;
        }

        .stat-label {
          font-size: 1rem;
          color: var(--text-secondary);
          font-weight: 500;
        }

        /* Insurance Partners Section */
        .insurance-section {
          background: var(--bg-page);
        }

        .insurance-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
          gap: 40px;
          align-items: center;
        }

        .insurance-card {
          background: white;
          padding: 30px;
          border-radius: var(--radius-lg);
          display: flex;
          align-items: center;
          justify-content: center;
          min-height: 120px;
          transition: all 0.3s ease;
          border: 2px solid transparent;
        }

        .insurance-card:hover {
          transform: translateY(-4px);
          border-color: var(--brand-yellow);
          box-shadow: 0 8px 25px rgba(255, 193, 7, 0.2);
        }

        .insurance-logo {
          max-width: 100%;
          max-height: 60px;
          width: auto;
          height: auto;
          object-fit: contain;
        }

        .insurance-placeholder {
          background: linear-gradient(135deg, var(--brand-yellow) 0%, var(--brand-yellow-dark) 100%);
          border: 3px dashed var(--brand-black);
        }

        .insurance-placeholder:hover {
          background: linear-gradient(135deg, var(--brand-yellow-light) 0%, var(--brand-yellow) 100%);
          border-color: var(--brand-black);
        }

        .insurance-plus {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          gap: 8px;
        }

        .plus-icon {
          font-size: 3rem;
          font-weight: 900;
          color: var(--brand-black);
          line-height: 1;
        }

        .plus-text {
          font-size: 1rem;
          font-weight: 700;
          color: var(--brand-black);
          text-align: center;
        }

        /* About Preview Section */
        .about-preview-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(400px, 1fr));
          gap: 60px;
          align-items: center;
        }

        .about-preview-image img {
          width: 100%;
          height: 500px;
          object-fit: cover;
          border-radius: var(--radius-lg);
          border: 3px solid var(--brand-yellow);
        }

        .section-title {
          font-family: 'Montserrat', sans-serif;
          font-weight: 900;
          font-size: clamp(2rem, 4vw, 3rem);
          line-height: 1.2;
          color: var(--text-primary);
          margin-bottom: 24px;
        }

        .section-subtitle {
          font-size: 1.2rem;
          color: var(--text-secondary);
          max-width: 600px;
          margin: 0 auto;
        }

        .about-preview-text {
          font-size: 1.1rem;
          line-height: 1.8;
          color: var(--text-secondary);
          margin-bottom: 32px;
        }

        .about-features {
          display: flex;
          flex-direction: column;
          gap: 16px;
        }

        .about-feature {
          display: flex;
          align-items: center;
          gap: 12px;
          font-size: 1rem;
          color: var(--text-primary);
        }

        .feature-icon {
          color: var(--brand-yellow);
          flex-shrink: 0;
        }

        /* Services Grid */
        .services-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
          gap: 32px;
        }

        .service-card {
          background: var(--bg-card);
          border-radius: var(--radius-lg);
          overflow: hidden;
          border: 1px solid var(--border-light);
          transition: all 0.3s ease;
          cursor: pointer;
        }

        .service-card:hover {
          transform: translateY(-8px);
          border-color: var(--brand-yellow);
          box-shadow: 0 10px 30px rgba(255, 193, 7, 0.2);
        }

        .service-image-container {
          position: relative;
          height: 240px;
          overflow: hidden;
        }

        .service-image {
          width: 100%;
          height: 100%;
          object-fit: cover;
          transition: transform 0.5s ease;
        }

        .service-card:hover .service-image {
          transform: scale(1.1);
        }

        .service-overlay {
          position: absolute;
          inset: 0;
          background: linear-gradient(180deg, transparent 0%, rgba(0, 0, 0, 0.6) 100%);
        }

        .service-content {
          padding: 24px;
        }

        .service-title {
          font-family: 'Montserrat', sans-serif;
          font-weight: 700;
          font-size: 1.4rem;
          color: var(--brand-yellow);
          margin-bottom: 12px;
        }

        .service-description {
          font-size: 0.95rem;
          line-height: 1.6;
          color: var(--text-secondary);
        }

        /* Testimonials */
        .testimonials-section {
          background: var(--bg-card);
        }

        .testimonials-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
          gap: 32px;
        }

        .testimonial-card {
          background: var(--bg-page);
          padding: 32px;
          border-radius: var(--radius-lg);
          border: 2px solid var(--border-light);
          transition: all 0.3s ease;
        }

        .testimonial-card:hover {
          border-color: var(--brand-yellow);
          transform: translateY(-4px);
        }

        .testimonial-rating {
          display: flex;
          gap: 4px;
          margin-bottom: 16px;
        }

        .testimonial-text {
          font-size: 1rem;
          line-height: 1.7;
          color: var(--text-secondary);
          margin-bottom: 20px;
          font-style: italic;
        }

        .author-name {
          font-weight: 700;
          color: var(--brand-yellow);
          font-size: 1.1rem;
          margin-bottom: 4px;
        }

        .author-date {
          font-size: 0.9rem;
          color: var(--text-secondary);
        }

        /* CTA Section */
        .cta-section {
          background: linear-gradient(135deg, var(--brand-yellow) 0%, var(--brand-yellow-dark) 100%);
          color: var(--brand-black);
        }

        .cta-content {
          text-align: center;
          max-width: 900px;
          margin: 0 auto;
        }

        .cta-title {
          font-family: 'Montserrat', sans-serif;
          font-weight: 900;
          font-size: clamp(2rem, 4vw, 3.5rem);
          color: var(--brand-black);
          margin-bottom: 20px;
          line-height: 1.2;
        }

        .cta-subtitle {
          font-size: 1.3rem;
          color: var(--brand-black);
          margin-bottom: 40px;
          opacity: 0.9;
        }

        .cta-buttons {
          display: flex;
          gap: 20px;
          justify-content: center;
          flex-wrap: wrap;
        }

        .cta-section .btn-primary {
          background: var(--brand-black);
          color: var(--brand-yellow);
        }

        .cta-section .btn-primary:hover {
          background: var(--brand-black-light);
        }

        .cta-section .btn-secondary {
          background: transparent;
          color: var(--brand-black);
          border-color: var(--brand-black);
        }

        .cta-section .btn-secondary:hover {
          background: var(--brand-black);
          color: var(--brand-yellow);
        }

        /* Responsive */
        @media (max-width: 767px) {
          .hero-section {
            padding: 100px 20px 60px;
            min-height: 85vh;
          }

          .hero-buttons {
            flex-direction: column;
          }

          .about-preview-grid {
            grid-template-columns: 1fr;
            gap: 40px;
          }

          .about-preview-image img {
            height: 350px;
          }

          .stats-grid {
            grid-template-columns: repeat(2, 1fr);
            gap: 24px;
          }

          .insurance-grid {
            grid-template-columns: repeat(2, 1fr);
            gap: 20px;
          }

          .insurance-card {
            padding: 20px;
            min-height: 100px;
          }

          .insurance-logo {
            max-height: 50px;
          }

          .services-grid {
            grid-template-columns: 1fr;
          }

          .testimonials-grid {
            grid-template-columns: 1fr;
          }

          .cta-buttons {
            flex-direction: column;
          }
        }
      `}</style>
    </div>
  );
};

export default Home;
